import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';
import CardLayout from '../../../../shared/components/card/CardLayout';

const Stat = () => (
    <div className="px-1 col-4 col-md-auto">
        <Placeholder className="skeleton skeleton-stat-value d-block mb-1" />
        <Placeholder className="skeleton skeleton-stat-label d-block" />
    </div>
);

export function ReportingOverviewSkeleton() {
    return (
        <CardLayout classCard="placeholder-glow">
            <Row aria-hidden="true">
                <Col className="d-flex justify-content-between align-items-center border-right-lg" lg={4}>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <Stat key={i} />
                    ))}
                </Col>
                <Col
                    className="d-flex flex-lg-row flex-wrap justify-content-between align-items-center mt-lg-0 mt-2"
                    lg={8}
                    style={{ rowGap: 8 }}
                >
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Stat key={i} />
                    ))}
                </Col>
            </Row>
        </CardLayout>
    );
}

function ReportingCardSkeleton() {
    return (
        <div className="reporting-card col-12 col-sm-6 col-lg-4 align-self-stretch mt-3 default-radius px-2">
            <CardLayout classBody="p-0">
                <div className="reporting-img-container">
                    <Placeholder className="skeleton skeleton-reporting-image" />
                </div>
                <div className="p-2 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <Placeholder className="skeleton skeleton-platform-icon" />
                        <div className="ml-1">
                            <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide d-block" />
                            <Placeholder className="skeleton skeleton-stat-label d-block mt-1" />
                        </div>
                    </div>
                    <Placeholder className="skeleton skeleton-action-btn skeleton-btn-sm" />
                </div>
            </CardLayout>
        </div>
    );
}
export function ReportingCampaignSkeleton({ cards = 2 }: { cards?: number }) {
    return (
        <CardLayout classCard="my-3 placeholder-glow">
            <div aria-hidden="true">
                <div className="d-flex flex-wrap justify-content-between" style={{ rowGap: 4 }}>
                    <div className="d-flex align-items-center w-md-auto w-100 mb-2 mb-md-0">
                        <Placeholder className="skeleton skeleton-influencer-avatar" />
                        <div className="d-flex flex-column ml-2">
                            <Placeholder className="skeleton skeleton-table-name d-block" />
                            <Placeholder className="skeleton skeleton-stat-label d-block mt-1" />
                        </div>
                    </div>
                    {Array.from({ length: 8 }).map((_, i) => (
                        <Stat key={i} />
                    ))}
                    <div className="col-4 col-md-auto d-flex flex-column align-items-md-end">
                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide d-block" />
                        <Placeholder className="skeleton skeleton-badge d-block mt-1" />
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
                    {Array.from({ length: cards }).map((_, i) => (
                        <ReportingCardSkeleton key={i} />
                    ))}
                </div>
            </div>
        </CardLayout>
    );
}
